import { inject, Injectable } from "@angular/core";
import {SsrCookieService} from 'ngx-cookie-service-ssr';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
 
    readonly cookieService = inject(SsrCookieService)

    setCookie(cookieName: string, cookieValue: string, expires?: number) {
        this.cookieService.set(cookieName, cookieValue, expires);
    }

    getCookie(cookieName: string): string {
        return this.cookieService.get(cookieName);
    }

    deleteCookie(cookieName: string) {
        this.cookieService.delete(cookieName);
    }

    deleteAllCookies() {
        this.cookieService.deleteAll();
    }
}